/* Ethnic Soul — Varanasi
   Cart behaviour. Everything here is progressive: the product form and the cart
   form both work as plain HTML posts if this script never runs. */

(function () {
  'use strict';

  var money = function (cents) {
    return '₹' + (cents / 100).toLocaleString('en-IN', { maximumFractionDigits: 0 });
  };

  /* ---------- header count ---------- */

  function paintCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count > 0 ? ' (' + count + ')' : '';
    });
  }

  function refreshCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { paintCount(cart.item_count); })
      .catch(function () { /* leave the server-rendered count alone */ });
  }

  /* ---------- add to bag ---------- */

  function bindProductForm() {
    var form = document.getElementById('product-form');
    if (!form) return;

    var button = form.querySelector('[name="add"]');
    var status = form.querySelector('[data-add-status]');

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (button.disabled) return;

      var original = button.textContent.trim();
      button.disabled = true;
      button.textContent = 'Adding…';
      if (status) status.textContent = '';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      })
        .then(function (r) {
          return r.json().then(function (body) {
            if (!r.ok) throw new Error(body.description || body.message || 'Could not add to bag');
            return body;
          });
        })
        .then(function () {
          button.textContent = 'Added to bag';
          if (status) {
            status.innerHTML = 'Added. <a href="/cart">View your bag</a>';
          }
          refreshCount();
          setTimeout(function () {
            button.textContent = original;
            button.disabled = false;
          }, 2200);
        })
        .catch(function (err) {
          button.textContent = original;
          button.disabled = false;
          if (status) status.textContent = err.message;
        });
    });
  }

  /* ---------- quantity stepper ---------- */

  function bindSteppers() {
    document.querySelectorAll('[data-qty]').forEach(function (wrap) {
      var input = wrap.querySelector('input');
      wrap.querySelectorAll('[data-step]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var min = parseInt(input.min || '1', 10);
          var next = (parseInt(input.value, 10) || min) + parseInt(btn.dataset.step, 10);
          input.value = Math.max(min, next);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* ---------- cart line updates ---------- */

  function bindCartLines() {
    var cart = document.querySelector('[data-cart]');
    if (!cart) return;

    cart.addEventListener('change', function (e) {
      var input = e.target.closest('input[name="updates[]"]');
      if (!input) return;

      var line = input.closest('[data-line]');
      cart.setAttribute('aria-busy', 'true');

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: Number(line.dataset.line), quantity: Number(input.value) })
      })
        .then(function (r) { return r.json(); })
        .then(function () { window.location.reload(); })
        .catch(function () { cart.removeAttribute('aria-busy'); });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    bindProductForm();
    bindSteppers();
    bindCartLines();
    refreshCount();
  });
})();
